export const getAmount = (paymentType, amount) => {
    if (paymentType === 'UPI') {
        return amount;
    } else {
        const amountWithFee = amount + amount * 0.02 + amount * 0.02 * 0.18;
        return Math.round(amountWithFee);
    }
};

export const getHikedPrice = (amount) => {
    const hikedAmount = (amount * 100) / 80;
    return Math.round(hikedAmount);
};

export const getTransationCharges = (amount) => {
    return Math.round(amount + amount * 0.02 + amount * 0.02 * 0.18 - amount);
};

export const getTaxAmount = (amount) => {
    return Math.round((amount * 0.05 * 100) / 100);
};

export const calculateBackpackingCustomPrice = (customPrice) => {
    if (!customPrice) return 0;
    const { room, perPerson, vehicle } = customPrice;
    const baseAmount = room + perPerson * 2 + vehicle?.[0]?.price;
    const hikedPrice = getHikedPrice(baseAmount);
    const discount = hikedPrice * 0.2;
    return Math.round(hikedPrice - discount);
};

export const calculateDisplayedPrice = (booking, packData, index, startCity) => {
    if (booking?.transport === 'Without transport') {
        return Math.round(getHikedPrice(packData?.withoutTransportPrice));
    }
    if (packData?.group === 'backpacking' && packData?.datesType === 'custom') {
        const customPrice =
            packData?.price[0]?.customPrice?.room +
            packData?.price[0]?.customPrice?.perPerson * 2 +
            (packData?.price[0]?.customPrice?.vehicle?.[0]?.price || 0);
        return Math.round(getHikedPrice(customPrice) / 2);
    } else {
        return Math.round(getHikedPrice(packData?.price[index]?.price.actual || 0));
    }
};

export const calculateOfferPrice = (booking, packData, index) => {
    if (booking?.transport === 'Without transport') {
        return packData?.withoutTransportPrice;
    }

    if (packData?.group === 'backpacking' && packData?.datesType === 'custom') {
        return Math.round(calculateBackpackingCustomPrice(packData?.price[0]?.customPrice) / 2);
    }

    return packData?.price[index]?.price.actual;
};
